import { render, staticRenderFns } from "./LearningPaths.vue?vue&type=template&id=dba8a2f0&scoped=true&"
import script from "./LearningPaths.vue?vue&type=script&lang=ts&"
export * from "./LearningPaths.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPaths.vue?vue&type=style&index=0&id=dba8a2f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba8a2f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dba8a2f0', component.options)
    } else {
      api.reload('dba8a2f0', component.options)
    }
    module.hot.accept("./LearningPaths.vue?vue&type=template&id=dba8a2f0&scoped=true&", function () {
      api.rerender('dba8a2f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/LearningPaths.vue"
export default component.exports